module.exports = __webpack_public_path__ + "static/media/empty-state-damage-maps.7337c1db.svg";